import { useAuthState } from "@synthesis/shared-auth";

type PopoverInfo = {
  userShortName: string;
  userName: string;
  userLastNameAndInitials: string;
  getUserRole: () => string;
  handleLogout: () => void;
};

export const usePopoverInfo = (): PopoverInfo => {
  const authStore = useAuthState();
  const currentUser = authStore.currentUser;

  const userLastName = currentUser?.lastName ?? "";
  const userFirstName = currentUser?.firstName ?? "";
  const userGivenName = currentUser?.givenName ?? "";
  const userFirstNameInitial = userFirstName[0] ?? "";
  const userGivenNameInitial = userGivenName[0] ?? "";

  const userName = `${userLastName} ${userFirstName} ${userGivenName}`;
  const userLastNameAndInitials = `${userLastName} ${userFirstNameInitial}. ${userGivenNameInitial}.`;
  const userShortName = `${userFirstName[0] ?? ""}${userLastName[0] ?? ""}`;

  const getUserRole = () => {
    if (!currentUser?.attributes) return "Роль отсутствует";
    const attributes = Array.isArray(currentUser.attributes) ? currentUser.attributes[0] : currentUser.attributes;
    return String(attributes ?? "Роль отсутствует");
  };

  const handleLogout = () => {
    authStore.logout();
  };

  return { userShortName, userName, userLastNameAndInitials, getUserRole, handleLogout };
};
